module.exports = angular.module('cartographer.plugin.layer.fba', [])

_ = require 'underscore'

module.exports.run $DI (crtLayer, fbaWindermereLayer, fbaWindermereSiteLayer) ->
  crtLayer.registerPlugin(fbaWindermereLayer)
  crtLayer.registerPlugin(fbaWindermereSiteLayer)
  return

module.exports.factory "fbaWindermereLayer", $DI (
  crtMarkerColor
  crtFeatureLayer
  crtAttributeLayer
) ->
  crtFeatureLayer.create({
    id: "FbaWindermere"
    name: "Windermere"
    selectionRadius: 50
    atlasMapId: "FbaWindermere"
    defaultMapEngine: "atlas"
    attributeGroups: [
      crtFeatureLayer.createAttributeGroup("site", "Site", [
        crtAttributeLayer.createAutoLookup("siteName", "Name")
        # crtAttributeLayer.createAutoLookup("siteDescription", "Description")
        crtAttributeLayer.createLookup("lakeOrRiver", "Lake/River", null, [
          { value: "Lake"  , color: crtMarkerColor.create("#27b6f3") }
          { value: "River" , color: crtMarkerColor.create("#27bf57") }
        ])
      ])
      crtFeatureLayer.createAttributeGroup("measurements", "Measured Parameters", [
        crtAttributeLayer.createAutoThreshold("temperature", "Temperature", "ÂºC")
        crtAttributeLayer.createAutoThreshold("electricalConductivity", "Electrical Conductivity", "ÂµS/cm")
        crtAttributeLayer.createThreshold("ph", "pH", null, [
          { value: 1  , color: crtMarkerColor.ph(1)  , label: "1"  }
          { value: 2  , color: crtMarkerColor.ph(2)  , label: "2"  }
          { value: 3  , color: crtMarkerColor.ph(3)  , label: "3"  }
          { value: 4  , color: crtMarkerColor.ph(4)  , label: "4"  }
          { value: 5  , color: crtMarkerColor.ph(5)  , label: "5"  }
          { value: 6  , color: crtMarkerColor.ph(6)  , label: "6"  }
          { value: 7  , color: crtMarkerColor.ph(7)  , label: "7"  }
          { value: 8  , color: crtMarkerColor.ph(8)  , label: "8"  }
          { value: 9  , color: crtMarkerColor.ph(9)  , label: "9"  }
          { value: 10 , color: crtMarkerColor.ph(10) , label: "10" }
          { value: 11 , color: crtMarkerColor.ph(11) , label: "11" }
          { value: 12 , color: crtMarkerColor.ph(12) , label: "12" }
          { value: 13 , color: crtMarkerColor.ph(13) , label: "13" }
          { value: 14 , color: crtMarkerColor.ph(14) , label: "14" }
        ])
        # Data not yet ready for release - crtAttributeLayer.createAutoThreshold("alkalinity", "Alkalinity", "mg/L as CaCO3")
        # Data not yet ready for release - crtAttributeLayer.createAutoThreshold("uv", "UV")
        # Data not yet ready for release - crtAttributeLayer.createAutoThreshold("chlorophyllA", "Chlorophyll-A", "Âµg/L")
        crtAttributeLayer.createAutoThreshold("totalPhosphorus", "Total Phosphorus", "mg P/L")
        # Data not yet ready for release - crtAttributeLayer.createAutoThreshold("totalDissolvedPhosphorus", "Total Dissolved Phosphorus", "mg P/L")
        crtAttributeLayer.createAutoThreshold("solubleReactivePhosphorus", "Soluble Reactive Phosphorus", "mg P/L")
        crtAttributeLayer.createLookup("wfdPhosphorusStatus", "WFD Phosphorus Status", null, [
          { value: "High" , color: crtMarkerColor.create("#27b6f3") }
          { value: "Good" , color: crtMarkerColor.create("#27bf57") }
          { value: "Moderate" , color: crtMarkerColor.create("#fffd2d") }
          { value: "Poor" , color: crtMarkerColor.create("#f0a923") }
          { value: "Bad" , color: crtMarkerColor.create("#df0012") }
        ])
        crtAttributeLayer.createAutoThreshold("totalAmmonia", "Total Ammonia", "mg N/L")
        crtAttributeLayer.createAutoThreshold("totalOxidisedNitrogen", "Total Oxidised Nitrogen", "mg N/L")
        crtAttributeLayer.createAutoThreshold("nitrate", "Nitrate", "mg N/L")
        crtAttributeLayer.createAutoThreshold("nitrite", "Nitrite", "mg N/L")
        crtAttributeLayer.createAutoThreshold("silica", "Silica", "mg SiO2/L")
        # Data not yet ready for release - crtAttributeLayer.createAutoThreshold("dissolvedOrganicCarbon", "Dissolved Organic Carbon", "mg C/L")
        crtAttributeLayer.createAutoThreshold("totalColiforms", "Total Coliforms", "cfu/100 ml")
        crtAttributeLayer.createAutoThreshold("eColi", "E-Coli", "cfu/100 ml")
        crtAttributeLayer.createAutoThreshold("intestinalEnterococci", "Intestinal Enterococci", "cfu/100 ml")
        crtAttributeLayer.createLookup("bathingWaterQuality", "Bathing Water Quality", null, [
          { value: "Excellent" , color: crtMarkerColor.create("#27b6f3") }
          { value: "Good" , color: crtMarkerColor.create("#27bf57") }
          { value: "Less than Good" , color: crtMarkerColor.create("#fffd2d") }
        ])
      ])
    ]
  })

module.exports.factory "fbaWindermereSiteLayer", $DI (
  crtMarkerColor
  crtFeatureLayer
  crtAttributeLayer
) ->
  crtFeatureLayer.create({
    id: "FbaWindermereSite"
    name: "Windermere Sites"
    selectionRadius: 500
    atlasMapId: "FbaWindermereSite"
    defaultMapEngine: "atlas"
    attributeGroups: [
      crtFeatureLayer.createAttributeGroup("Site", "Site", [
        crtAttributeLayer.createAutoLookup("name", "Name")
        crtAttributeLayer.createAutoLookup("description", "Description")
      ])
    ]
  })
